export default __webpack_public_path__ + "static/media/81.e1d807fb.png";